/**
 * This file is the place to add any functionality to the app that does not need to interact with the app itself.
 * - PWA registration
 * - Page refreshing
 * - Version checking
 *
 * This file is meant to be as simple as reasonable. Try to limit the amount of external dependencies.
 */

import { VERSION_FILE_URL } from 'utilities/consts.js';
import { makeRequest } from 'utilities/fetch/api-gateway.js';
import { getWindow, setWindow } from 'utilities/window.js';

// Setup the app namespace
const MetService = getWindow()?.MetService || {};
setWindow('MetService', MetService);

(async () => {
  console.log(__VERSION__);
  const checkVersionPromise = makeRequest<Record<'Version' | 'BuildDate' | 'CommitHash', string>>({
    path: VERSION_FILE_URL,
    options: { cache: 'no-store' },
    apiPrefix: false,
  });
  const checkVersion = await checkVersionPromise;
  if (checkVersion?.Version && MetService) {
    MetService.versionInfo = checkVersion.Version;
  }
})();

// // Register a PWA
// const registerPWA = () => {
//   if (!inIframe() && 'serviceWorker' in navigator) {
//     getWindow()?.addEventListener('load', () => {
//       navigator.serviceWorker
//         .register('/service-worker.js')
//         .then((registration) => {
//           registration.onupdatefound = () => {
//             const installingWorker = registration.installing;
//             if (installingWorker == null) {
//               return;
//             }
//             installingWorker.onstatechange = () => {
//               if (installingWorker.state === 'installed') {
//                 if (navigator.serviceWorker.controller) {
//                   console.info('New content is available.');
//                   getWindowLocation().reload();
//                 } else {
//                   console.info('Content is cached for offline use.');
//                 }
//               }
//             };
//           };
//         })
//         .catch((error) => {
//           console.error('Error during service worker registration:', error);
//         });
//     });
//   }
// };

// // Remove any PWA for this site
// function unregisterPWA() {
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.ready.then((registration) => {
//       registration.unregister();
//     });
//   }
// }

// // PWA is turned off for now
// if (process?.env?.['ENABLE_PWA']) {
//   registerPWA();
// } else {
//   unregisterPWA(); // Just in case
// }

// const APP_REFRESH_TIMEOUT = 1000 * 60 * 60; // hour
// const INTERVAL_PERIOD = 1000 * 60 * 10; // 10 minutes
// const APP_START = Date.now();
// let mouseLastMovedTime = APP_START;

/**
 Check every ten minutes.
 If it has been an hour since the checks started,
 AND the user has not moved the mouse since the last check,
 then reload the page.

 example 1: A user loads the page and looks at info for 5 minutes, then leaves the tab open for an hour without using the site.
 At one hour from the page loading, the page will reload and the hourly check starts over.

 example 2: A user loads the page and looks at info off and on for 90 minutes. The user then stops using the site, leaving the tab open. Within
 10 to 20 minutes from when the user stopped using the site, the page will reload and the hourly check starts over.
 */
// setInterval(() => {
//   const currentTime = Date.now();
//   const isOverAppRefreshTime = currentTime - APP_START > APP_REFRESH_TIMEOUT;
//   const mouseHasntMovedDuringInterval = currentTime - mouseLastMovedTime > INTERVAL_PERIOD;
//   if (isOverAppRefreshTime && mouseHasntMovedDuringInterval) {
//     getWindowLocation().reload();
//   }
// }, INTERVAL_PERIOD);

// // Simple utility debounce method. Defined here so that nothing has to be imported.
// const debounce = (func: () => void, wait: number) => {
//   let timeout: ReturnType<typeof setTimeout> | null = null;
//   return () => {
//     timeout && clearTimeout(timeout);
//     timeout = setTimeout(() => {
//       timeout = null;
//       func();
//     }, wait);
//   };
// };

// // Track mouse movement on the site and record when mouse stops moving.
// getWindow()?.addEventListener(
//   'mousemove',
//   debounce(() => {
//     mouseLastMovedTime = Date.now();
//   }, 1000),
// );

// const VERSION_CHECK_INTERVAL = 1000 * 60 * 10;

// const fetchVersionNumber = () => {
//   return fetch(VERSION_FILE_URL, { cache: 'no-store' })
//     .then((response) => {
//       return response.json();
//     })
//     .catch(console.warn);
// };

// Display version info on first load and store the version info
// fetchVersionNumber().then((versionInfo: IVersionInfo) => {
//   console.info(`:: MetService version: ${versionInfo['Version']}  Built on ${versionInfo['BuildDate']} ::`);
//   MetService.versionInfo = versionInfo;
// });

// if (MetService.autoupdate) {
//   // Check the version info on the server
//   setInterval(() => {
//     fetchVersionNumber().then((versionInfo: IVersionInfo) => {
//       // If the previous fetch failed, just store the new version info
//       if (!MetService.versionInfo || !MetService.versionInfo.Version) {
//         MetService.versionInfo = versionInfo;
//         return;
//       }

//       // Make sure the version that was just fetched makes sense
//       if (!versionInfo || !versionInfo.Version) {
//         return;
//       }

//       // If the versions do not match, reload the page
//       if (MetService.versionInfo.Version !== versionInfo.Version) {
//         getWindowLocation().reload();
//       }
//     });
//   }, VERSION_CHECK_INTERVAL);
// }
